import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 0, label: "Em digitação" },
    { value: 1, label: "Aguardando análise" },
    { value: 2, label: "Revisar solicitação" },
    { value: 3, label: "Agendamento solicitado" },
    { value: 4, label: "Vistoria solicitada" },
    { value: 5, label: "Concluído" },
    { value: 6, label: "Arquivado" }
];

const SituacaoSolicVistoria = ({ field, placeholder, name, id, disabled=false }) => {
    return (
        <Select 
            options={options} 
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
        />
    )
}

export { SituacaoSolicVistoria, options as OpcoesSituacaoSolicVistoria }